export default __webpack_public_path__ + "static/media/2106_30B.f95e4ee8.jpg";